// デザイン部から指定された 20 色を使用する
export const COLORS: string[] = [
  "#F48FB1", // ピンク200
  "#C51162", // ピンクA700
  "#E040FB", // パープルA200
  "#CAB3F6", // ペールパープル
  "#AB47BC", // パープル400
  "#4527A0", // ディープパープル800
  "#9FA8DA", // インディゴ300
  "#42A5F5", // ブルー400
  "#B3E5FC", // ブルー100
  "#00E5FF", // シアンA400
  "#1DE9B6", // ティールA400
  "#388E3C", // グリーン700
  "#AFB42B", // ライム700
  "#AEEA00", // ライムA700
  "#FFEA00", // イエローA400
  "#FFB300", // 黄色600,
  "#FF8A65", // ディープオレンジ300
  "#BCAAA4", // ブラウン200
  "#7B4341", // ブラウン600@
  "#607D8B" // ブルーグレー500
];

// グラフに表示する値の min, max のマージン値
// Example: 5 が指定されている場合は + 5 した値がグラフ描画時の最大値, - 5 した値が最小値となる
export const MARGIN_VALUE = 10;
